/**
 * Axios configuration with interceptors
 * 
 * This file configures axios with interceptors to:
 * 1. Pass the GA4 client ID to the backend
 * 2. Add common headers to all requests
 * 3. Handle errors consistently
 */

import axios from 'axios';

/**
 * Configure axios with interceptors
 */
export const configureAxios = (): void => {
  // Request interceptor
  axios.interceptors.request.use(
    (config) => {            
      // Add language header
      const currentLang = document.documentElement.lang || navigator.language || 'en';
      if (config.headers) {
        config.headers['Accept-Language'] = currentLang;
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Log errors but don't interfere with error handling
      console.error('API request failed:', error);
      return Promise.reject(error);
    }
  );
};

export default configureAxios;
